import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import AreaTitle from '../../../components/areaTitle/AreaTitle';
import useTutorialChapters from '../../system/tutorials/useTutorialChapters';
import TutorialStatsTable from './components/TutorialStatsTable';
import useAdminTutorialsStats from './hooks/useAdminTutorialsStats';

/**
 * AdminTutorials - Os tutoriais estão sendo úteis? (Admin Geral)
 *
 * Uma tabela por capítulo, na ordem atual de tutorials.json, com os números somados de todas
 * as empresas: quantos abriram, quantos assistiram, onde param, quantos chegaram pela ajuda
 * da tela e as respostas de "Esta aula ajudou?". A ligação é pelo id fixo de cada lição.
 */
function AdminTutorials() {
  const { chapters, loading: chaptersLoading, error: chaptersError } = useTutorialChapters();
  const { statsById, totals, isLoading, error, includeTest, setIncludeTest, refresh } = useAdminTutorialsStats();
  const loading = chaptersLoading || isLoading;

  return (
    <Box sx={{ backgroundColor: '#F8F9FC', minHeight: '100vh', p: { xs: 2, md: 3 } }}>
      <Box sx={{ mb: 3 }}>
        <AreaTitle
          Title="Admin Geral · Tutoriais"
          Icon={<SchoolOutlinedIcon />}
          Description="Uso dos tutoriais por lição, somando todas as empresas. Sem as empresas de teste, os admins da plataforma ficam de fora."
        />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap' }}>
          <FormControlLabel
            control={<Switch checked={includeTest} onChange={(e) => setIncludeTest(e.target.checked)} size="small" />}
            label={<Typography variant="body2">Incluir empresas de teste</Typography>}
          />
          <Typography variant="body2" color="text.secondary">
            Pessoas: <strong>{totals.users}</strong>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Empresas: <strong>{totals.companies}</strong>
          </Typography>
        </Box>

        <Button variant="outlined" startIcon={<RefreshOutlinedIcon />} onClick={refresh} disabled={loading}>
          Atualizar
        </Button>
      </Box>

      {(error || chaptersError) && (
        <Alert severity="error" sx={{ mb: 2 }}>{error || 'Não foi possível carregar a lista de tutoriais.'}</Alert>
      )}

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
          <CircularProgress size={32} />
        </Box>
      ) : (
        chapters.map((chapter) => <TutorialStatsTable key={chapter.id} chapter={chapter} statsById={statsById} />)
      )}
    </Box>
  );
}

export default AdminTutorials;
